import { Link } from "react-router-dom";
import { GenderIcon, PerformerName, TagLink } from "src/components/fragments";
import { ROUTE_SCENES } from "src/constants";
import type { FingerprintAlgorithm, PerformerFragment } from "src/graphql";
import { createHref, formatDuration, performerHref, tagHref } from "src/utils";

type Appearance = {
  performer: PerformerFragment;
  as: string;
};

export const renderPerformer = (appearance: {
  as?: string | null;
  performer: Pick<
    Appearance["performer"],
    "name" | "id" | "gender" | "disambiguation" | "deleted"
  >;
}) => (
  <Link key={appearance.performer.id} to={performerHref(appearance.performer)}>
    <GenderIcon gender={appearance.performer.gender} />
    <PerformerName performer={appearance.performer} as={appearance.as} />
  </Link>
);

export const renderTag = (tag: {
  id: string;
  name: string;
  description?: string | null;
}) => (
  <TagLink title={tag.name} link={tagHref(tag)} description={tag.description} />
);

export const renderFingerprint = (fingerprint: {
  hash: string;
  duration: number;
  algorithm: FingerprintAlgorithm;
}) => (
  <>
    <Link to={`${createHref(ROUTE_SCENES)}?fingerprint=${fingerprint.hash}`}>
      {fingerprint.algorithm}: {fingerprint.hash}
    </Link>
    <span title={`${fingerprint.duration}s`}>
      {", duration: "}
      {formatDuration(fingerprint.duration)}
    </span>
  </>
);
